import { TravelFundingSource } from '@/module/Travel/Request/model/TravelRequestTypes';

import { TravelAggregates } from './model/TravelRegistryTypes';

export const TRAVEL_TREND_YEARS = 6;

export function travelTrendWindow(year: number) {
  return { from: year - TRAVEL_TREND_YEARS + 1, to: year };
}

const numberFormat = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 2 });

export function formatTravelNumber(value: number) {
  return numberFormat.format(value);
}

export const travelFundingGroupList = ['UMFST', 'PROJECTS', 'ERASMUS', 'OTHER'] as const;
export type TravelFundingGroup = (typeof travelFundingGroupList)[number];

const FUNDING_GROUP: Record<TravelFundingSource, TravelFundingGroup> = {
  UMFST: 'UMFST',
  UMFST_OWN_REVENUE: 'UMFST',
  PROJECT_FUNDS: 'PROJECTS',
  ERASMUS_FUNDS: 'ERASMUS',
  ORGANIZERS: 'OTHER',
  SPONSORS: 'OTHER',
  PARTICIPANT: 'OTHER',
};

export function travelFundingByGroup(row: TravelAggregates): Record<TravelFundingGroup, number> {
  const totals = { UMFST: 0, PROJECTS: 0, ERASMUS: 0, OTHER: 0 };
  row.byFundingSource.forEach(amount => {
    // A funding source the backend adds before this map does still carries money, so it falls into OTHER.
    totals[FUNDING_GROUP[amount.fundingSource] ?? 'OTHER'] += amount.amountEur;
  });
  return totals;
}

export interface TravelDelta {
  absolute: number;
  percent: number | null;
}

export function travelDeltaOf(current: number, previous: number | undefined): TravelDelta | null {
  if (previous === undefined) {
    return null;
  }
  const absolute = current - previous;
  return { absolute, percent: previous === 0 ? null : (absolute / previous) * 100 };
}

export function travelErasmusShare(row: TravelAggregates): number | null {
  return row.trips === 0 ? null : (row.erasmus.trips / row.trips) * 100;
}
